import type { AddUpdateRoleRequestType } from '@/modules/masters/roles/components/NewRolePopup';
import { userModule } from '@/module/userModule';
import ApiService from '@/services/apiService';
import { handleResult } from '@/helpers/utils/functionality-utils';
import type { StoreBaseResponse } from '@/types/types';

export class RolesService {
  private userApiService: ApiService;
  constructor() {
    this.userApiService = new ApiService(userModule);
  }

  async userRoles(): Promise<StoreBaseResponse> {
    const response = await this.userApiService.get('/api/v1/master/roles');
    const result: StoreBaseResponse = {
      error: false,
      message: '',
      status_code: 0,
    };
    if (response.data.error) {
      return {
        error: true,
        message: response.data.message,
        status_code: response.data.status_code,
      };
    }
    result.data = response.data.data;
    return result;
  }

  async permissions(): Promise<StoreBaseResponse> {
    const response = await this.userApiService.get(
      '/api/v1/master/permissions',
    );
    const result: StoreBaseResponse = {
      error: false,
      message: '',
      status_code: 0,
    };

    if (response.data.error) {
      return {
        error: true,
        message: response.data.message,
        status_code: response.data.status_code,
      };
    }
    result.data = response.data.data;
    return result;
  }

  async addNewRole(body: AddUpdateRoleRequestType) {
    const response = await this.userApiService.post<null>(
      '/api/v1/auth/role/add',
      body,
    );

    return handleResult(response);
  }

  async updateRole(body: AddUpdateRoleRequestType) {
    const response = await this.userApiService.post<null>(
      `/api/v1/auth/role/${body.id}/modify`,
      {
        role: body.role,
        permissions: body.permissions,
        //excluding id
      },
    );
    return handleResult(response);
  }
}
